import React from 'react';
import { Button } from '../Button';
import { cn } from '../../lib/utils';
export const ContentBlockCopySectionCentered = ({ title, content, ctaChildren, ctaAriaLabel, className, }) => {
    return (React.createElement("section", { className: cn(['mt-8 mb-16 px-8 md:px-14 space-y-8 max-w-[55rem] mx-auto', className]) },
        React.createElement("hr", { className: "border-t-[0.5px] border-brand-navy" }),
        React.createElement("div", { className: "space-y-6" },
            React.createElement("h2", { className: "font-medium text-[32px]/[1.3] md:text-[40px]/[1.1] tracking-[-0.03em] text-brand-navy-2" }, title),
            React.createElement("div", { className: "text-base tracking-[-0.03em] text-brand-navy [&_*:last-child]:mb-0" }, content)),
        ctaChildren && (React.createElement(Button, { asChild: true, variant: "text", "aria-label": ctaAriaLabel }, ctaChildren))));
};
